import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Bottom Heavy / Core' second='Workout 03' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Banded Glutes / Quads',
							value: 'High Knees',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Plank Crunches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 secs',
						},
					],
					[
						{
							header: '(A) Banded Glutes / Quads',
							value: 'Touchdown Lunges',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 20',
						},
						{
							header: 'ABS / Core',
							value: 'Plank',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
					[
						{
							header: '(A) Banded Glutes / Quads',
							value: 'Pulse Squats',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Rest',
						},
						{
							header: 'Sec / Minutes',
							value: '...',
						},
					],
					[
						{
							header: '(A) Banded Glutes / Quads',
							value: 'Side Steps',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Bicycle Crunches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Banded Glutes / Quads',
							value: 'Glute Bridge',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 20',
						},
						{
							header: 'ABS / Core',
							value: '6 inches',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
